var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 2H14V1.4C13.9473 0.610865 13.2909 -0.0017556 12.5 3.77998e-06H1.5C0.709104 -0.0017556 0.0527246 0.610865 0 1.4V16.6C0.0527246 17.3891 0.709104 18.0018 1.5 18H3V18.6C3.05272 19.3891 3.7091 20.0018 4.5 20H15.5C16.2909 20.0018 16.9473 19.3891 17 18.6V3.4C16.9473 2.61087 16.2909 1.99824 15.5 2ZM1 16.6V1.4C1.04824 1.16344 1.25862 0.995135 1.5 1H12.5C12.7414 0.995135 12.9518 1.16344 13 1.4V16.6C12.9518 16.8366 12.7414 17.0049 12.5 17H1.5C1.25862 17.0049 1.04824 16.8366 1 16.6ZM15.5 19C15.7414 19.0049 15.9518 18.8366 16 18.6V3.4C15.9518 3.16344 15.7414 2.99514 15.5 3H14V16.6C13.9473 17.3891 13.2909 18.0018 12.5 18H4V18.6C4.04824 18.8366 4.25862 19.0049 4.5 19H15.5Z",
    fill: "#0066CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.6588c6f1fc67809f5c5bb4686aacba1b.svg";
export { ForwardRef as ReactComponent };